import React, {Component} from 'react';
import { Row, Col, ButtonToolbar, ToggleButton, ToggleButtonGroup } from 'react-bootstrap';
import _ from 'lodash';
import GroupHeader from './group-header';

class BrandsFilter extends Component {
  render() {
    const {
      brands,
      filterBox,
      onBrandFilterChange,
      fetchingProducts
    } = this.props;

    if (!brands) {
      return (<div></div>);
    }

    const brandButtons = _.uniqBy(brands, 'id').map(brand => (
      <ToggleButton
        key={`brand-${brand.id}`}
        value={brand.id}
        disabled={fetchingProducts}
      >
        <img alt={brand.name} className="filter-image" src={brand.links.image}/>
      </ToggleButton>
    ));

    return (
      <Row className="brands-filter">
        <Col lg={12}>
          <GroupHeader>Brands</GroupHeader>
          <ButtonToolbar>
            <ToggleButtonGroup
              type="checkbox"
              onChange={onBrandFilterChange}
              value={filterBox.brands}
            >
              {brandButtons}
            </ToggleButtonGroup>
          </ButtonToolbar>
        </Col>
      </Row>
    );
  }
}

export default BrandsFilter;



// WEBPACK FOOTER //
// ./src/components/product-page/filters/brands-filter.jsx